import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Fragment } from 'react';

interface VerticalStepperProps {
    activeStep: string | number;
    steps: Step[];
    onSelection: (stepId: string | number) => void;
}

export interface Step {
    id: string | number;
    title: string;
    description: string;
    icon: IconDefinition;
}

export default function VerticalStepper({ steps, activeStep, onSelection }: VerticalStepperProps) {
    return (
        <div className='flex mx-auto items-center justify-center lg:grid lg:grid-cols-v-stepper lg:items-start lg:justify-start'>
            {steps.map((step, index) => (
                <Fragment key={step.id}>
                    <div
                        className={`w-10 h-10 border ${activeStep === step.id ? 'bg-loving-500 text-white border-transparent' : 'bg-white text-gray-500 border-gray-300'} rounded-full flex items-center justify-center cursor-pointer transition ease-in-out relative`}
                        onClick={() => onSelection(step.id)}
                    >
                        <FontAwesomeIcon icon={step.icon} />
                        {activeStep === step.id && (
                            <div className='lg:hidden absolute top-full left-1/2 transform -translate-x-1/2 text-gray-700 w-24 mt-2 text-xs font-semibold text-center'>
                                {step.title}
                            </div>
                        )}
                    </div>
                    <div className='hidden lg:block col-start-2 row-span-2 pl-3' onClick={() => onSelection(step.id)}>
                        <div className={`${activeStep === step.id
                            ? 'text-oswalds-900 font-semibold'
                            : 'text-gray-500 font-medium'}`}>
                            {step.title}
                        </div>
                        <div className={`font-medium text-xs ${activeStep === step.id ? 'text-gray-500' : 'text-gray-400'}`}>{step.description}</div>
                    </div>
                    {index < (steps.length - 1) && (
                        <div className='w-8 md:w-16 lg:w-auto lg:h-24 flex justify-center px-2 lg:py-3 lg:px-0'>
                            <div className='w-full h-px lg:w-px lg:h-full bg-gray-200' />
                        </div>
                    )}
                    
                </Fragment>
            ))}
        </div>
    )
}